import { render, staticRenderFns } from "./ProviderNotificationCreateForm.vue?vue&type=template&id=592126ad&scoped=true&"
import script from "./ProviderNotificationCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProviderNotificationCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592126ad",
  null
  
)

export default component.exports